module.exports = __webpack_public_path__ + "img/body.0ef5e52e.png";